import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccessLog } from '../../shared/models/access-log.model';

@Component({
    selector: 'access-logs',
    imports: [CommonModule],
    templateUrl: './access-logs.component.html',
    styleUrl: './access-logs.component.scss'
})
export class AccessLogsComponent {
  @Input() accessLogs: AccessLog[] = [];
}
